import { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { LogOut, Moon, Sun } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import PageHeader from '../../components/kit/PageHeader';
import CategoriesTab from './CategoriesTab';
import DataTab from './DataTab';
import IntegrityTab from './IntegrityTab';

type Tab = 'categories' | 'data' | 'check' | 'account';

export default function Settings({ theme, onToggleTheme }: { theme: 'light' | 'dark'; onToggleTheme: () => void }) {
  const [tab, setTab] = useState<Tab>('categories');
  const user = getAuth().currentUser;
  return (
    <div className="space-y-5">
      <PageHeader title="Cài đặt" question="Danh mục, sao lưu, tài khoản" />
      <Tabs value={tab} onValueChange={v => setTab(v as Tab)}><TabsList className="flex w-full max-w-lg justify-start sm:grid sm:grid-cols-4"><TabsTrigger value="categories">Danh mục</TabsTrigger><TabsTrigger value="data">Dữ liệu</TabsTrigger><TabsTrigger value="check">Kiểm tra</TabsTrigger><TabsTrigger value="account">Tài khoản</TabsTrigger></TabsList></Tabs>
      {tab === 'categories' && <CategoriesTab />}
      {tab === 'data' && <DataTab />}
      {tab === 'check' && <IntegrityTab />}
      {tab === 'account' && (
        <Card><CardContent className="space-y-4 p-4">
          <div><p className="text-xs text-muted-foreground">Đăng nhập bằng</p><p className="font-medium">{user?.displayName ?? '—'}</p><p className="text-sm text-muted-foreground">{user?.email}</p></div>
          <div className="flex flex-wrap gap-2">
            <Button variant="outline" onClick={onToggleTheme}>{theme === 'dark' ? <Sun size={15} aria-hidden /> : <Moon size={15} aria-hidden />} Chế độ {theme === 'dark' ? 'sáng' : 'tối'}</Button>
            <Button variant="outline" onClick={() => signOut(getAuth())}><LogOut size={15} aria-hidden /> Đăng xuất</Button>
          </div>
          <p className="text-xs text-muted-foreground">Tiền tệ: VNĐ · Ngôn ngữ: Tiếng Việt. Dữ liệu được đồng bộ theo thời gian thực qua Firebase và chỉ bạn đọc được.</p>
        </CardContent></Card>
      )}
    </div>
  );
}
